import React, { useEffect, useState } from "react";
import { useAuth } from "../../../firebase/AuthProvider";
import { useNavigate, useParams } from "react-router-dom";
import Waiver from "../../../interfaces/participant/Waiver";
import {
  getParticipantInfo,
  getWaivers,
  postParticipantBump,
} from "../../../services/participantServices/ParticipantService";
import Select, { SingleValue } from "react-select";
import Banner from "../../ui/Banner/Banner";
import AssignedParticipant from "../../../interfaces/participant/AssignedParticipant";
import Unauthorized from "../errorPages/Unauthorized";
import { Button } from "react-bootstrap";
import backarrowbtn from '../../../assets/images/backarrowbtn.svg';

interface OptionType {
  value: string;
  label: string;
}

const BumpParticipantForm: React.FC = ({ }) => {
  // Eventually we are going to want to set a gloabl region and get that information
  // to POST new participants to
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const [waivers, setWaivers] = useState<Waiver[] | null>([]);
  const [wavierSelection, setWaiverSelection] = useState<string>();
  const [participant, setParticipant] = useState<AssignedParticipant>();
  const { participantId } = useParams<{ participantId: string }>();
  const [waiverOptions, setWaiverOptions] = useState<OptionType[]>([]);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  useEffect(() => {
    const fetchInfo = async () => {
      if (currentUser) {
        const authToken: string = await currentUser.getIdToken();
        const waiversFetched = await getWaivers(authToken);

        if (waiversFetched.success) {
          setWaivers(waiversFetched.data);
        }
      }
    };

    fetchInfo();
  }, [currentUser]); // Only re-fetch when currentUser changes

  useEffect(() => {
    if (waivers && waivers.length > 0) {
      const formattedWaivers = waivers.map((waiver) => ({
        value: waiver.id.toString(),
        label: waiver.waiverName,
      }));
      setWaiverOptions(formattedWaivers);
    }
  }, [waivers]); // React only when employees or waivers state changes

  useEffect(() => {
    const fetchInfo = async () => {
      if (currentUser && participantId) {
        const authToken: string = await currentUser.getIdToken();
        const fetchedParticipant = await getParticipantInfo(
          participantId,
          authToken
        );

        if (fetchedParticipant === "unauthorized") {
          return <Unauthorized />
        } else if (fetchedParticipant) {
          setParticipant(fetchedParticipant);
        }
      }
    };
    fetchInfo();
  }, [participantId]); // React only when employees or waivers state changes

  const handleWaiverChange = (selectedOption: SingleValue<OptionType>) => {
    const waiverId = selectedOption ? selectedOption.value : "";
    setWaiverSelection(waiverId);
  };

  const submit = async () => {
    setIsLoading(true);
    if (wavierSelection && currentUser && participantId) {
      const authToken = await currentUser.getIdToken();
      await postParticipantBump(participantId, wavierSelection, authToken);
      setErrorMessage("");
      navigate("/dashboard/owner/participants");
    } else {
      console.error("Unable to submit creation");
    }
    setIsLoading(false);
  };

  const dismissBanner = () => {
    setErrorMessage("");
  };

  return (
    <>
      <div className="new_activity_container">
        <div className="common_card">
          <div className="top border_tittle top_bar_flx justify-content-start align-items-start">
            <button><img style={{width: '1.5rem'}} src={backarrowbtn} alt="backarrowbtn" onClick={()=> navigate("/dashboard/owner/participants")} /></button>
            <div className="top_bar_tittle">
              <h2>Bump Participant Form</h2>
              <p> Please use this form to change the participating waiver of a participant.</p>
            </div>
          </div>
          <div className="max-w-screen-sm mx-auto">
            {errorMessage !== "" && (
              <Banner
                status="error"
                message={errorMessage}
                dismissBanner={dismissBanner}
              />
            )}
          </div>
          {/* Form information here */}
          <div className="custom_input_flled">
            <label>Participant</label>
            <div className="form-control">
              {participant?.firstName} {participant?.lastName}
            </div>
          </div>
          <div className="custom_input_flled">
            <label>Participant Waiver</label>
            <div className="remove-input-txt-border ms-1">
              <Select
                options={waiverOptions}
                value={
                  waiverOptions.find(
                    (option) => option.value === wavierSelection
                  ) || null
                }
                onChange={handleWaiverChange}
                className="react-select-container"
                classNamePrefix="react-select"
              />
            </div>
          </div>
          <div className="form_btn_flx mby_t_24">
            {isLoading ? (
              <Button variant="primary" disabled>Loading...</Button>
            ) : (
              <Button variant="primary" onClick={submit}>Submit</Button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BumpParticipantForm;
